module.exports = __webpack_public_path__ + "static/media/b5.d1edc3d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sangwenfeng/b5.mp3
// module id = HDf4
// module chunks = 0